// extracted by mini-css-extract-plugin
export default {"customTabs":"tabs_customTabs__utyHy","MuiTab-root":"tabs_MuiTab-root__EOdEg","Mui-selected":"tabs_Mui-selected__RxALU","tab":"tabs_tab__ewnFD","activeTab":"tabs_activeTab__u1lRt"};